import React, { useEffect } from 'react';
import AppRoutes from '../app-routes';
import api from '../services/apiService';
import getProducts from '../redux/actions/products/getProducts';
import themeLoader from '../async-theme-loader';

import { useDispatch } from "react-redux";
import { BrowserRouter } from 'react-router-dom';

function App() {

  const dispatch = useDispatch();

  useEffect(() => {
    themeLoader(process.env.REACT_APP_THEME);
  }, []);

  useEffect(() => {
    dispatch(getProducts());
  }, [dispatch]);


  // triggers when page reloads, act as component will mount
  api.setAccessToken();

  api.setCompanyKey();

  return (
    <>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </>
  );
}

export default App;
